import { render, staticRenderFns } from "./mendian.vue?vue&type=template&id=61be20f5&scoped=true&"
import script from "./mendian.vue?vue&type=script&lang=js&"
export * from "./mendian.vue?vue&type=script&lang=js&"
import style0 from "./mendian.vue?vue&type=style&index=0&id=61be20f5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61be20f5",
  null
  
)

export default component.exports